<template>
  <div>
    <PersonEditComponent
      ref="_personForm"
      :person="props.person"
    />
    <AddressEditComponent
      v-show="visibleAddress"
      ref="_addressForm"
      :address="props.address"
      :show-full-name="false"
    />
  </div>
</template>

<script setup lang="ts">

import {ref} from "vue";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import PersonEditComponent from "@/modules/OrganisationStructure/components/PersonEditComponent.vue";
import AddressEditComponent from "@/modules/OrganisationStructure/components/AddressEditComponent.vue";



interface Props {
  person:Person,
  address:Address,
  visibleAddress?:boolean
}
const props = withDefaults(defineProps<Props>(), {
  visibleAddress : true,
    person: () => new Person(),
    address: () => {
      const t = new Address();
      t.countryCode = "DE"
      return t;
    },
  }
)

const _personForm = ref<InstanceType<typeof PersonEditComponent>  | null>(null)
const _addressForm = ref<InstanceType<typeof AddressEditComponent>  | null>(null)

const validate = ( ):boolean => {
  const checkAddress  = _addressForm.value.validate();
  const checkPerson = _personForm.value.validate();
 return checkPerson&& checkAddress;
}

const getAddress = ():Address => {
  return _addressForm.value.getAddress();
}
const getPerson = ():Person => {
  return _personForm.value.getPerson();
}


defineExpose({
  validate, getAddress, getPerson
})

</script>

<style scoped>

</style>
